'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');
var ReactPlayer = _interopDefault(require('react-player'));

var VIDEO_PLAYER_ERRORS = {
  notSupported: "This video is not supported",
  invalidUrl: "Invalid URL, please try a different link"
};

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", "\n  ", "\n  \n  font-family: Source Sans Pro, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n\n  position: relative;\n  padding-top: 56.25%;\n\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  .player-error-message {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: ", ";\n  }\n\n  @media (max-width: 767px) {\n    ", "\n    ", "\n  }\n"], ["\n  ", "\n  ", "\n  \n  font-family: Source Sans Pro, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n\n  position: relative;\n  padding-top: 56.25%;\n\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  .player-error-message {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: ", ";\n  }\n\n  @media (max-width: 767px) {\n    ", "\n    ", "\n  }\n"]);

var Container = styled__default.div(_templateObject, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return props.padding && "padding: " + props.padding;
}, settings.COLOR.textBlack, function (props) {
  return props.mPadding && "padding: " + props.mPadding;
}, function (props) {
  return props.mMargin && "margin: " + props.mMargin;
});

var VideoPlayer = function VideoPlayer(_ref) {
  var src = _ref.src,
      options = _ref.options,
      onReady = _ref.onReady,
      onError = _ref.onError,
      onStart = _ref.onStart,
      onEnded = _ref.onEnded,
      validationErrors = _ref.validationErrors,
      props = _babelHelpers.objectWithoutProperties(_ref, ["src", "options", "onReady", "onError", "onStart", "onEnded", "validationErrors"]);

  var _ref2 = options || {},
      _ref2$controls = _ref2.controls,
      controls = _ref2$controls === undefined ? true : _ref2$controls;

  var _useState = React.useState(null),
      _useState2 = _babelHelpers.slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var handleOnReady = function handleOnReady(e) {
    if (validationErrors) {
      setError(VIDEO_PLAYER_ERRORS.notSupported);
      onError(validationErrors);
      return;
    }

    setError(null);

    if (onReady) onReady(e);
  };

  var handleOnStart = function handleOnStart(e) {
    if (onStart) onStart(e);
  };

  var handleOnEnded = function handleOnEnded(e) {
    if (onEnded) onEnded(e);
  };

  var handleOnError = function handleOnError() {
    setError(VIDEO_PLAYER_ERRORS.notSupported);

    if (onError) onError(VIDEO_PLAYER_ERRORS.invalidUrl);
  };

  return React__default.createElement(
    Container,
    props,
    React__default.createElement(ReactPlayer, {
      url: src,
      controls: controls,
      onReady: handleOnReady,
      onError: handleOnError,
      onStart: handleOnStart,
      onEnded: handleOnEnded,
      className: "react-player",
      width: "100%",
      height: "100%",
      config: {
        facebook: {
          attributes: {
            // fix bug with Facebook vertical videos overflowing
            height: "188px",
            padding: "0"
          }
        }
      }
    }),
    error && React__default.createElement(
      "div",
      { className: "player-error-message" },
      error
    )
  );
};

VideoPlayer.propTypes = {
  src: PropTypes$1.string,
  options: PropTypes$1.object,
  onError: PropTypes$1.func,
  onReady: PropTypes$1.func,
  onStart: PropTypes$1.func,
  onEnded: PropTypes$1.func
};
VideoPlayer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VideoPlayer",
  "props": {
    "src": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "options": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "onError": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onReady": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onStart": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onEnded": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};

module.exports = VideoPlayer;
//# sourceMappingURL=video-player.js.map
